import React from "react";

const MODALITY_OPTIONS = [
  { value: "todos", label: "Todos" },
  { value: "comprar", label: "Comprar" },
  { value: "alugar", label: "Alugar" },
];

function PropertyFilters({
  sort,
  onSortChange,
  city,
  onCityChange,
  cityOptions,
  neighborhood,
  onNeighborhoodChange,
  neighborhoodOptions,
  hasActiveFilters,
  onClear,
  showModality = false,
  modality,
  onModalityChange,
}) {
  return (
    <div className="listing-filters">
      <div className="listing-filters__bar">
        {showModality && (
          <div className="listing-filters__segmented" role="group" aria-label="Finalidade">
            {MODALITY_OPTIONS.map((option) => (
              <button
                key={option.value}
                type="button"
                className={
                  modality === option.value
                    ? "is-active"
                    : undefined
                }
                onClick={() => onModalityChange(option.value)}
              >
                {option.label}
              </button>
            ))}
          </div>
        )}

        <div className="listing-filters__field">
          <label htmlFor="listing-sort">Ordenar</label>
          <select
            id="listing-sort"
            value={sort}
            onChange={(e) => onSortChange(e.target.value)}
          >
            <option value="relevancia">Relevância</option>
            <option value="menor-preco">Menor preço</option>
            <option value="maior-preco">Maior preço</option>
          </select>
        </div>

        <div className="listing-filters__field">
          <label htmlFor="listing-city">Cidade</label>
          <select
            id="listing-city"
            value={city}
            onChange={(e) => onCityChange(e.target.value)}
          >
            <option value="">Todas as cidades</option>
            {cityOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        <div className="listing-filters__field">
          <label htmlFor="listing-neighborhood">Bairro</label>
          <select
            id="listing-neighborhood"
            value={neighborhood}
            onChange={(e) => onNeighborhoodChange(e.target.value)}
            disabled={neighborhoodOptions.length === 0}
          >
            <option value="">Todos os bairros</option>
            {neighborhoodOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {hasActiveFilters && (
          <button
            type="button"
            className="listing-filters__clear"
            onClick={onClear}
          >
            Limpar filtros
          </button>
        )}
      </div>

      {hasActiveFilters && (
        <div className="listing-filters__chips">
          {city && (
            <span className="listing-filters__chip">
              Cidade: {city}
              <button
                type="button"
                aria-label="Remover filtro de cidade"
                onClick={() => onCityChange("")}
              >
                ×
              </button>
            </span>
          )}
          {neighborhood && (
            <span className="listing-filters__chip">
              Bairro: {neighborhood}
              <button
                type="button"
                aria-label="Remover filtro de bairro"
                onClick={() => onNeighborhoodChange("")}
              >
                ×
              </button>
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export default PropertyFilters;
